import { render, staticRenderFns } from "./TokenSearch.vue?vue&type=template&id=bed679ae"
import script from "./TokenSearch.vue?vue&type=script&lang=js"
export * from "./TokenSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports